import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {Lock} from 'lucide-react';
import styles from './HomePage.module.scss';
import { DEBUG, PATH } from '../../utils/constants';
import Footer from '../../components/Footer/Footer';

// Imports à ajouter :
import Hero from '../../components/Home/Hero/Hero';
import HowItWorks from '../../components/Home/HowItWorks/HowItWorks';
import FeaturedGames from '../../components/Home/FeaturedGames/FeaturedGames';
import TransientCard from '../../components/Home/TransientCard/TransientCard';

import { LanguageContext } from '../../context/LanguageContext';

import { getAllGames } from '../../utils/api/gamesAPI';
import { getLastInsertedGame } from '../../utils/api/transientGameAPI';
import GameSlider from '../../utils/GameSlider/GameSlider';

// Import des traductions 
import translations from '../../utils/translations/HomeTranslations';


const path = PATH;
const debug = DEBUG;


const HomePage = () => {

    // Utilisation du contexte de langue global et accès simplifié aux traductions
    const { language } = useContext(LanguageContext);
    const t = translations[language] || translations.fr;

    const [loadingGames, setLoadingGames] = useState(true);

    // const jeuxInsolites = [
    //     { id: 1, nom: "Deuches de France", image: "/assets/img/Annonce.jpg" },
    //     { id: 2, nom: "Domaine de Pérréal", image: "/assets/img/2cv1.jpg" },
    // ];

    const [lastGame, setLastGame] = React.useState(null);

    const navigate = useNavigate();

    const [allGames, setAllGames] = useState([]);

    useEffect(() => {
        async function fetchGames() {
            try {
                setLoadingGames(true);
                const jeux = await getAllGames();
                if (debug) console.log('🧪 Données brutes récupérées via getAllGames():', jeux);

                const jeuxValides = jeux
                    .filter(j => j.id && j.nom) // image peut être null
                    .map(j => ({
                        id: j.id,
                        nom: j[`nom_${language}`] ?? j.nom, // prend nom_${language} si défini, sinon nom
                        image: j.image ? `${path}${j.image}` : '/assets/img/default.jpg', // fallback image
                        entreprise: j.company_name ?? "", // nom de l'entreprise
                        adresse: j.company_address ?? "", // adresse de l'entreprise
                        telephone: j.company_phone ?? "", // telephone de l'entreprise
                        email: j.company_email ?? "", // email de l'entreprise
                    }));

                if (debug) console.log('✅ Données nettoyées pour le slider :', jeuxValides);
                setAllGames(jeuxValides);
                setLoadingGames(false);
            } catch (err) {
                if (debug) console.error('Erreur lors de la récupération des jeux insolites :', err);
            }
        }

        fetchGames();
    }, [language]);

    React.useEffect(() => {
        async function fetchLastGame() {
            try {
                const game = await getLastInsertedGame();
                if (game) setLastGame(game);
            } catch (error) {
                if (debug) console.error("Erreur lors de la récupération du dernier jeu :", error);
                setLastGame(null);
            }
        }
    
        fetchLastGame();
    }, []);

    const handleVillagesClick = () => {
        navigate('/choix-village');
    };
    const handleOtherGameClick = () => { // Dépannage - Pour le moment charge uniquement parcours Deuches de France - Pour généraliser avec admin => Nouveau devis : 480€ HT
        navigate('/start-game?jeu=1'); // + image du jeu à charger en fonction...
    };
    const handleTransientGameClick = () => { 
        if (lastGame && lastGame.active) {
            navigate(`/load-game?jeu=${lastGame.id}`); 
        } else {
            // alert("Le jeu n’est pas encore actif.");
        }
    };


    return (
        <>
            {/* TEST */}
            <Hero
                title={t.welcomeMess}
                tagline={t.smallTxt}
                badges={['⏱ 45–60 min', 'Tout public']}
                synopsis={t.p1Txt}
                // primaryLabel={t.villageGameTitle}
                primaryLabel={"Comment ça fonctionne ?"}
                secondaryLabel={'C\'est parti !'}
                goLabel={'Voir tous les jeux'}
                onPrimary={handleVillagesClick}
                onSecondary={() => navigate('/jeux-insolites')}
            />

            {/* <div className={styles.textContainer}>
                <h2>{t.welcomeMess}</h2>
                <p className={styles.small}>{t.smallTxt}</p>
                <p className={styles.paragraph}>{t.p1Txt}.</p>
                
            </div> */}
            <div className={styles.homeContainer}>
                <div className={styles.animatedBorder}>
                    <div className={styles.shine}></div>
                    <div className={styles.gameButton1} onClick={handleVillagesClick}>
                        <p className={styles.h2}>{t.villageGameTitle}</p>
                        {/* <hr /> */}
                        <p className={styles.subTitleGreen}>{t.free}</p>
                    </div>
                </div>
                <p className={styles.paragraph}><strong>{t.villagesTxtStrong}</strong><span>{t.villagesTxt}</span></p>
                {/* <div className={styles.gameButton3} onClick={handleOtherGameClick}>{t.otherGameTitle}</div> */}
                
                <GameSlider
                    jeux={allGames}
                    onSelect={(id) => {
                        if (id === 'liste') {
                        navigate('/jeux-insolites');
                        } else {
                        navigate(`/start-game?jeu=${id}`);
                        }
                    }}
                />
                <p className={styles.paragraph}><strong>{t.independantTxtStrong}</strong><span>{t.independantTxt}</span></p>

                <div className={styles.animatedBorder}>
                    <div className={styles.shine}></div>
                    <div className={styles.gameButton2} 
                        onClick={handleTransientGameClick}
                        style={{
                            backgroundImage: lastGame && lastGame.image ? `linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url(${path}${lastGame.image})` : 'none',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }} >
                            <p>{lastGame ? lastGame.nom : t.lockedGameTitle}</p><p className={styles.subTitleGreen}>{t.free}</p> {!lastGame || !lastGame.active ? <p><Lock /></p> : null}
                    </div>
                </div>
                <p className={styles.paragraph}><strong>{t.transientTxtStrong}</strong><span>{t.transientTxt}</span></p>
                
            </div>

            {/* Ton paragraphe + slider */}
            {/* <FeaturedGames
            jeux={allGames}
            loading={loadingGames}
            onSelect={(id) => {
                if (id === 'liste') navigate('/jeux-insolites');
                else navigate(`/start-game?jeu=${id}`);
            }}
            /> */}

            {/* Carte “jeu éphémère” */}
            {/* <TransientCard
            lastGame={lastGame}
            active={!!(lastGame && lastGame.active)}
            backgroundUrl={lastGame?.image ? `${path}${lastGame.image}` : undefined}
            titleFallback={t.lockedGameTitle}
            freeLabel={t.free}
            onClick={handleTransientGameClick} */}
            {/* /> */}

            {/* <HowItWorks title={t.howTitle ?? 'Comment ça marche ?'} /> */}

            <div className={styles.textContainer}>
                <p className={styles.paragraph}>{t.introText}</p>
            </div>

            <Footer />
        </>
        
    );
};

export default HomePage;
